<template>
    <div class="property-list" v-if="currentComponent">
        <h3>{{ $t('contrato_rastreabilidade.messages.view.contract_data_title') }}</h3>
        <el-card>
            <component
                v-model="report.properties"
                :is="currentComponent"
                ref="PropertyListComponent"
            />
        </el-card>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'ContractData',
    props: {
        selected: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            components: {
                'PY': () =>
                    import(
                        '@/modules/traceability-contract/views/pages/view/components/contract-data/py.vue'
                    )
            }
        };
    },
    computed: {
        ...mapState('traceabilityContractModule', ['report']),
        currentComponent() {
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    }
};
</script>

<style scoped lang="scss">
h3 {
    margin: 16px 0;
    color: #3b3b3b;
    font-weight: 500;
    font-size: 16px;
}
</style>
